/**
 * IE condition
 * https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */
if (/*@cc_on!@*/ false || !!document.documentMode) {
    // css object-fit polyfill
    // https://github.com/fregante/object-fit-images
    objectFitImages()

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach
    }
}
